import React, { useState, useEffect, Fragment } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Row, Col, Table, Spinner } from "react-bootstrap";
import Add from "./Add";
import ErrorModal from "../ErrorModal";
import useAuth from "../../hooks/useAuth";
import DeleteConfirmation from "../shared/DeleteConfirmation";
import MyJustDate from "../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API_JOBS;
const isSmallDevice = window.innerWidth <= 600; // Define the breakpoint for small devices

const Listdelete = ({ mekhraz_id }) => {
  const [moamads, setMoamads] = useState([]);
  const [activeMekhrazeem, setActiveMekhrazeem] = useState([]);
  const [moamadId, setMoamadId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [refreshMomads, setRefreshMoamads] = useState(false);
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate("application/json");
  //const navigate = useNavigate();
  //const location = useLocation();

  const { auth } = useAuth();

  useEffect(() => {
    const getActiveMekhrazeem = async () => {
      const response = await axiosPrivate
        .get("jobs/activemekhrazeem")
        .then((response) => {
          setActiveMekhrazeem(
            response.data.map((item) => ({
              ...item,
              title_mkhnum: `${item.title} ${item.mkh_num}`,
            }))
          );
        });
    };
    getActiveMekhrazeem();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamadootforuser?user_id=" + auth.user_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMoamads(
            response.data.sort((a, b) => {
              return b.id - a.id;
            })
          );
          setLoading(false);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            //navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, [refreshMomads]);

  const handleEditClick = (event, mmd) => {
    event.preventDefault();
    setMoamadId(mmd.id);
  };
  const handleCancelClick = () => {
    setMoamadId(null);
  };
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    if (!moamads) return null;
    return (
      <>
        <div>
          <Add
            setRefreshMoamads={setRefreshMoamads}
            user={auth.user_id}
            idz={auth.user}
            activeMekhrazeem={activeMekhrazeem}
          />
        </div>
        <div className="mt-4">
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form>
                <Table hover>
                  <tbody>
                    {moamads?.map((mmd) => (
                      <Fragment key={mmd.id}>
                        <ReadOnlyRows
                          mmd={mmd}
                          handleEditClick={handleEditClick}
                          setRefreshMoamads={setRefreshMoamads}
                          setMoamadId={setMoamadId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>

        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  mmd,
  handleEditClick,
  setMoamadId,
  setRefreshMoamads,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  let history = useNavigate();
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const now = MyJustDate(new Date());
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(
      `מחיקת מועמדות למכרז "${mmd.mekhraz.title}": האם אתה בטוח? `
    );
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    async function deletePost() {
      let isMounted = true;
      const controller = new AbortController();
      const getData = async () => {
        try {
          const response = await axiosPrivate.delete(
            baseURL + "moamad/" + mmd.id,
            {
              signal: controller.signal,
            }
          );
          isMounted && setRefreshMoamads((prev) => !prev);
          alert("נמחקה בהצלחה");
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              //navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };
      getData();
    }
    deletePost();
    setMoamadId(null);
  };
  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={mmd.id}
        event={deleteObj}
        message={deleteMessage}
      />
      {isSmallDevice && (
        <tr>
          <td colSpan="6" style={{ textAlign: "center", fontWeight: "bold" }}>
            {mmd.mekhraz.title}
          </td>
        </tr>
      )}
      <tr
        style={{
          color: mmd.signature_date
            ? "blue"
            : MyJustDate(new Date(mmd.mekhraz.hagsha_date)) < now
            ? "black"
            : "red",
        }}
        className="right-aligned-row"
      >
        <td style={{ fontWeight: "bold" }}>
          {!isSmallDevice ? mmd.mekhraz.title : null}
        </td>
        <td>
          {MyJustDate(new Date(mmd.mekhraz.hagsha_date)) < now
            ? "נסגר"
            : "פעיל"}
        </td>
        <td>{mmd.signature_date ? "שוגר" : "לא שוגר"}</td>
        <td>{mmd.mekhraz.mkh_num}</td>
        <td>{mmd.mekhraz.hagsha_date}</td>
        <td style={{ textAlign: "left" }}>
          <Button
            variant={
              MyJustDate(new Date(mmd?.extention_date)) >= now
                ? "success"
                : mmd.signature_date
                ? "danger"
                : MyJustDate(new Date(mmd.mekhraz.hagsha_date)) < now
                ? "danger"
                : "success"
            }
            value={mmd.id}
            onClick={() =>
              history(
                "/moamadoot/" +
                  mmd.id +
                  "/" +
                  encodeURIComponent(mmd.mekhraz.title) +
                  "/" +
                  mmd.mekhraz.hagsha_date
              )
            }
          >
            {MyJustDate(new Date(mmd?.extention_date)) >= now
              ? "נפתח"
              : mmd.signature_date
              ? "צפייה"
              : MyJustDate(new Date(mmd.mekhraz.hagsha_date)) < now
              ? "צפייה"
              : "ניהול"}
          </Button>

          <span> </span>
          {false && (
            <button
              type="button"
              className="btn btn-danger"
              onClick={(event) => showDeleteModal("moamadoot", mmd.id, event)}
            >
              הסרה
            </button>
          )}
        </td>
      </tr>
    </>
  );
};
